import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const PropertyComparison = ({ properties, isOpen, onClose, onRemove }) => {
  if (!isOpen || properties?.length === 0) return null;

  const features = [
    { key: 'price', label: 'Prix', icon: 'DollarSign' },
    { key: 'bedrooms', label: 'Chambres', icon: 'Bed' },
    { key: 'bathrooms', label: 'Salles de bain', icon: 'Bath' },
    { key: 'area', label: 'Surface', icon: 'Maximize' },
    { key: 'type', label: 'Type', icon: 'Home' },
    { key: 'location', label: 'Quartier', icon: 'MapPin' },
    { key: 'status', label: 'Statut', icon: 'CheckCircle' }
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="bg-slate-900 border border-white/10 rounded-3xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-white/10">
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-white">
              Comparaison de propriétés
            </h2>
            <p className="text-sm text-slate-400 mt-1">
              {properties?.length} propriété{properties?.length > 1 ? 's' : ''} sélectionnée{properties?.length > 1 ? 's' : ''}
            </p>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full hover:bg-slate-800 flex items-center justify-center transition-colors"
            aria-label="Close comparison"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="flex-1 overflow-auto p-4 md:p-6">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[800px]">
              <thead>
                <tr>
                  <th className="text-left p-4 bg-slate-800/50 rounded-tl-lg">
                    <span className="text-sm font-semibold text-white">Caractéristiques</span>
                  </th>
                  {properties?.map((property) => (
                    <th key={property?.id} className="p-4 bg-slate-800/50">
                      <div className="relative">
                        <button
                          onClick={() => onRemove(property?.id)}
                          className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-red-500 text-white flex items-center justify-center hover:bg-red-600 transition-colors"
                          aria-label="Remove from comparison"
                        >
                          <Icon name="X" size={14} />
                        </button>
                        <div className="aspect-video rounded-lg overflow-hidden mb-3">
                          <Image
                            src={property?.image}
                            alt={property?.imageAlt}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <h3 className="text-sm font-semibold text-white line-clamp-2">
                          {property?.title}
                        </h3>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {features?.map((feature, index) => (
                  <tr key={feature?.key} className={index % 2 === 0 ? 'bg-slate-800/20' : ''}>
                    <td className="p-4">
                      <div className="flex items-center gap-2">
                        <Icon name={feature?.icon} size={18} className="text-blue-400" />
                        <span className="text-sm font-medium text-white">{feature?.label}</span>
                      </div>
                    </td>
                    {properties?.map((property) => (
                      <td key={property?.id} className="p-4 text-center">
                        <span className="text-sm text-white">
                          {feature?.key === 'price'
                            ? `${property?.[feature?.key]?.toLocaleString('fr-FR')} CDF`
                            : feature?.key === 'area'
                            ? `${property?.[feature?.key]} m²`
                            : feature?.key === 'status'
                            ? property?.[feature?.key] === 'available' ? 'Disponible' : property?.[feature?.key] === 'rented' ? 'Loué' : 'Réservé'
                            : property?.[feature?.key]
                          }
                        </span>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            {properties?.map((property) => (
              <Button
                key={property?.id}
                variant="default"
                fullWidth
                iconName="Eye"
                iconPosition="left"
                onClick={() => {
                  window.location.href = `/real-estate-portal/property/${property?.id}`;
                }}
              >
                Voir {property?.title?.split(' ')?.[0]}
              </Button>
            ))}
          </div>
        </div>

        <div className="p-4 md:p-6 border-t border-white/10">
          <div className="flex items-start gap-3 p-4 bg-blue-500/10 rounded-lg border border-blue-500/20">
            <Icon name="Info" size={20} className="text-blue-400 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-white mb-1">
                Besoin d'aide pour choisir?
              </p>
              <p className="text-xs text-slate-400">
                Contactez nos agents immobiliers pour une consultation personnalisée et des recommandations adaptées à vos besoins.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyComparison;
